export default "__VITE_ASSET__64ec9136__"